import { request } from '@/shared/api/request'

export const sendCodeToEmail = (payload) => {
	return request({ url: `/user/password/reset?email=${payload.email}`, method: 'POST' })
}
